<div class="main-content">
  <!-- Google Tag Manager (noscript) -->
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5VKDT44"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  <section class="access">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="clearfix"></div>
          <div class="i18n">
            <button [disabled]="confirming" [class.active]="lang === 'ja'" (click)="changeLanguage('ja')">日本語</button>
            <button [disabled]="confirming" [class.active]="lang === 'en'" (click)="changeLanguage('en')">English</button>
            <button [disabled]="confirming" [class.active]="lang === 'zh-CN'" (click)="changeLanguage('zh-CN')">简体中文</button>
          </div>
          <div class="clearfix"></div>
          @if (!member.visitors) {
            <ul class="step">
              <li><span [class.en]="lang === 'en'">{{ 'selectAGymBranch' | translate }}</span></li>
              <li class="active"><span [class.en]="lang === 'en'">{{ 'enterYourDetails' | translate }}</span></li>
              <li><span>{{ 'confirm' | translate }}</span></li>
              <li><span>{{ 'complete' | translate }}</span></li>
            </ul>
          }
          <div class="clearfix"></div>
          @if (reservationGlobalFlag && !member.visitors && !member.isRegistration && isDisplayedTourPlan === 1 && visitMenu.length) {
            <div class="app-type">
              <div class="app-type-item">
                <button class="app-type-button" [disabled]="confirming" [class.active]="member.isEntry" (click)="switchToEntry()">{{ 'webMembership' | translate }}</button>
              </div>
              <div class="app-type-item">
                <button class="app-type-button" [disabled]="confirming" [class.active]="!member.isEntry" (click)="switchToVisit()">{{ 'visitReservation' | translate }}</button>
              </div>
            </div>
          }
          <form novalidate #stepTwoForm="ngForm" autocomplete="on" (ngSubmit)="next()">
            <fieldset [disabled]="confirming">
            @if (requiresQuestionary && (questionaryLoading || (!questionaryLoaded && !questionaryError))) { <p role="status">アンケートを読み込んでいます…</p> }
            @if (requiresQuestionary && questionaryError) {
              <div role="alert">{{ questionaryError }}</div>
              <button type="button" (click)="loadQuestionary()" [disabled]="questionaryLoading">アンケートを再取得</button>
            }
            <div class="application">
              @if (visitorsError) {
                <div class="visitors_error">
                  <p>{{member.tmp.studio?.[1]}}は、<br/>見学予約の受付を行っておりません。</p>
                </div>
              }
              <div [style.display]="member.visitors ? 'flex' : 'unset'" [style.flex-flow]="member.visitors ? 'column-reverse' : 'unset'">
                <div>
                  <!-- Visit Reservation Plan Selection -->
                  @if (!member.visitors && !member.isEntry) {
                    <div class="mb30">
                      <h2 class="title">{{ 'selectMembershipType' | translate }}</h2>
                      <p>{{ 'selectMembershipTypeMsg' | translate }}</p>
                      <div class="application-row">
                        <div class="col-label">
                          <label class="contact-label">{{ 'selectMembershipType' | translate }}</label>
                          <span class="required">{{ 'required' | translate }}</span>
                        </div>
                        <div class="col-form">
                          <div class="form-group col-md-12 row">
                            @if (!selectVisitPlan) { <div class="error"><p>{{ 'requiredMsgDefault' | translate }}</p></div> }
                            <input type="hidden" [(ngModel)]="selectVisitPlan" name="requiredVisitPlan" required>
                            @for (plan of visitMenu; track plan.id) {
                              <div class="radio">
                                <label style="width:100%;">
                                  <input type="radio" [(ngModel)]="selectVisitPlan" name="selectVisitPlan" [value]="plan.id" (ngModelChange)="onSelectVisitPlanChange()">
                                  {{plan.menuName}} 所要時間: {{plan.requiredTime}}分
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <!-- Visit Date -->
                      <div class="application-row">
                        <div class="col-label">
                          <label class="contact-label">{{ 'visitDate' | translate }}</label>
                          <span class="required">{{ 'required' | translate }}</span>
                        </div>
                        <div class="col-form form-inline">
                          @if (!visitDatetime) { <div class="error"><p>{{ 'requiredMsgDefault' | translate }}</p></div> }
                          <input type="hidden" [(ngModel)]="visitDatetime" name="requiredVisitDatetime" required>
                          <div class="form-group col-md-12 row">
                            <label class="col-form-label" style="margin-bottom: 1rem">{{visitDatetime}}</label>
                            <div class="pb-2">
                              <button class="btn fleft" style="background: #7595c7; color:white; margin-right: 1%"
                                type="button" (click)="openVisitModal()" [disabled]="!selectVisitPlan">
                                {{ 'visitDate' | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <!-- Visit Note -->
                      <div class="application-row">
                        <div class="col-label"><label class="contact-label">{{ 'visitNote' | translate }}</label></div>
                        <div class="col-form form-inline">
                          <div class="form-group col-md-12 row">
                            <textarea class="form-control" rows="3" [(ngModel)]="visitNote" name="visitNote"
                              [placeholder]="'visitNotePlaceholder' | translate" style="width:100%" maxlength="255" sfMaxLength="255"></textarea>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  }

                  <!-- Membership Plan Selection -->
                  @if (!member.visitors && member.isEntry) {
                    <div class="mb30">
                      <h2 class="title">{{ 'selectMembershipType' | translate }}</h2>
                      <p>{{ 'selectMembershipTypeMsg' | translate }}</p>
                      <div class="application-row">
                        <div class="col-label">
                          <label class="contact-label">{{ 'membershipCategory' | translate }}</label>
                          <span class="required">{{ 'required' | translate }}</span>
                        </div>
                        <div class="col-form">
                          <div class="form-group col-md-12 row">
                            @if (!selectPlan) { <div class="error"><p>{{ 'membershipCategoryRequired' | translate }}</p></div> }
                            <input type="hidden" [(ngModel)]="selectPlan" name="requiredPlan" required>
                            @for (plan of plans; track plan.id) {
                              <div class="radio">
                                <label style="width:100%;">
                                  <input type="radio" [(ngModel)]="selectPlan" name="selectPlan"
                                    [value]="plan.id + ',' + plan.name + ',' + plan.time + ',' + plan.incTaxMonthlyFee"
                                    (ngModelChange)="onSelectPlanChange()">
                                  {{plan.name}}({{lang === 'ja' ? plan.time : plan.time.replace('時間', 'h')}})月会費{{plan.incTaxMonthlyFee | number:'1.0-0'}}円(税込)
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  }

                  <!-- Basic Info -->
                  <h2 class="title">{{ 'basicInfoInput' | translate }}</h2>
                  @if (!member.visitors && member.isEntry) { <p>{{ 'basicInfoInputMsg' | translate }}</p> }
                  @if (member.visitors || !member.isEntry) { <p>{{ 'pleaseEnterYourInformation' | translate }}</p> }

                  <!-- Full Name -->
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'fullName' | translate }}</label>
                      <span class="required">{{ 'required' | translate }}</span>
                    </div>
                    <div class="col-form form-inline">
                      @if (!member.lastName) { <div class="error"><p>{{ 'lastNameRequired' | translate }}</p></div> }
                      @if (!member.firstName) { <div class="error"><p>{{ 'firstNameRequired' | translate }}</p></div> }
                      @if (!member.lastNameKana) { <div class="error"><p>{{ 'lastNameKanaRequired' | translate }}</p></div> }
                      @if (!member.firstNameKana) { <div class="error"><p>{{ 'firstNameKanaRequired' | translate }}</p></div> }
                      <div class="form-group col-md-12 row">
                        <label class="w70 col-xs-3 col-lg-2" style="padding:0">{{ 'kanji' | translate }}</label>
                        <div class="col-xs-4 col-lg-5">
                          <input class="form-control" [placeholder]="'lastNameLabel' | translate" type="text" [(ngModel)]="member.lastName" name="lastName" required>
                        </div>
                        <div class="col-xs-4 col-lg-5">
                          <input class="form-control" [placeholder]="'firstNameLabel' | translate" type="text" [(ngModel)]="member.firstName" name="firstName" required>
                        </div>
                      </div>
                      <div class="form-group col-md-12 row">
                        <label class="w70 col-xs-3 col-lg-2" style="padding:0">{{ 'kana' | translate }}</label>
                        <div class="col-xs-4 col-lg-5">
                          <input class="form-control" [placeholder]="'lastNameKanaLabel' | translate" type="text" [(ngModel)]="member.lastNameKana" name="lastNameKana" required>
                        </div>
                        <div class="col-xs-4 col-lg-5">
                          <input class="form-control" [placeholder]="'firstNameKanaLabel' | translate" type="text" [(ngModel)]="member.firstNameKana" name="firstNameKana" required>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <!-- Gender (entry only) -->
                  @if (member.isEntry) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label">{{ 'gender' | translate }}</label>
                        <span class="required">{{ 'required' | translate }}</span>
                      </div>
                      <div class="col-form form-inline">
                        @if (!selectSex) { <div class="error"><p>{{ 'genderRequired' | translate }}</p></div> }
                        <div class="form-group w100p col-md-12 row">
                          <select class="form-control" style="width:30%" [(ngModel)]="selectSex" name="sex" required>
                            <option [ngValue]="null">{{ 'pleaseSelect' | translate }}</option>
                            @for (sex of sexes; track sex.id) {
                              <option [ngValue]="sex">{{ sex.name | translate }}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }

                  <!-- Address (entry only) -->
                  @if (member.isEntry) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label">{{ 'address' | translate }}</label>
                        <span class="required">{{ 'required' | translate }}</span>
                      </div>
                      <div class="col-form form-inline">
                        @if (!member.tmp.zip1 || !member.tmp.zip2) { <div class="error"><p>{{ 'postcodeRequired' | translate }}</p></div> }
                        @if (!member.visitors && (!member.province || !member.city || !member.area)) { <div class="error"><p>{{ 'addressRequired' | translate }}</p></div> }
                        <div class="form-group w100p col-md-12 row">
                          <div class="col-lg-12 col-xs-12">
                            <label class="w40 fleft">〒</label>
                            <input convertAlphanumeric class="form-control col-lg-2 fleft" [placeholder]="lang === 'ja' ? '半角数字' : ''"
                              style="width:30%;" type="text" pattern="[0-9]+" sfMaxLength="3"
                              [(ngModel)]="member.tmp.zip1" name="zip1" required>
                            <span class="fleft spacePostcode">-</span>
                            <input convertAlphanumeric class="form-control col-lg-3" style="width:30%;" type="text"
                              pattern="[0-9]+" sfMaxLength="4" [(ngModel)]="member.tmp.zip2" name="zip2" required>
                          </div>
                        </div>
                        @if (!member.visitors) {
                          <div class="form-group col-md-12 row" style="width:100%">
                            <span class="btn fleft" style="background:#7595c7;color:white;margin-right:1%"
                              (click)="searchZipCode(member.tmp.zip1, member.tmp.zip2)">{{ 'autofill' | translate }}</span>
                            <div style="padding-top:10px">
                              <a href="http://www.post.japanpost.jp/zipcode/" target="_blank">{{ 'postcodeSearch' | translate }}</a>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                          <div class="form-group w70p"><input class="form-control w100p" [placeholder]="'prefecture' | translate" type="text" [(ngModel)]="member.province" name="province" required></div>
                          <div class="form-group w70p"><input class="form-control w100p" [placeholder]="'cityTownArea' | translate" type="text" [(ngModel)]="member.city" name="city" required></div>
                          <div class="form-group w70p"><input class="form-control w100p" [placeholder]="'addressLine' | translate" type="text" [(ngModel)]="member.area" name="area" required></div>
                          <div class="form-group w70p"><input class="form-control w100p" [placeholder]="'buildingNameRoomNumber' | translate" type="text" [(ngModel)]="member.address" name="building"></div>
                        }
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }

                  <!-- Date of Birth -->
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'dateOfBirth' | translate }}</label>
                      <span class="required">{{ 'required' | translate }}</span>
                    </div>
                    <div class="col-form form-inline">
                      @if (!member.tmp.birth_year || !member.tmp.birth_month || !member.tmp.birth_date) { <div class="error"><p>{{ 'dateOfBirthRequired' | translate }}</p></div> }
                      @if (!isEligibleAge(member.tmp.birth_year, member.tmp.birth_month, member.tmp.birth_date)) { <div class="error"><p>高校生以下の方は保護者同伴の上店舗でのお手続きをお願い致します</p></div> }
                      <input type="hidden" [ngModel]="isEligibleAge(member.tmp.birth_year, member.tmp.birth_month, member.tmp.birth_date) ? 'true' : ''" name="eligibleBirthDate" required>
                      <div class="form-group w100p col-md-12 row">
                        <div class="col-lg-3 col-xs-4" style="padding:0">
                          <select class="form-control" style="width:80%" [(ngModel)]="member.tmp.birth_year" name="birthYear" required>
                            <option [ngValue]="undefined">{{ 'year' | translate }}</option>
                            @for (y of birthYears; track y) { <option [ngValue]="y">{{y}}</option> }
                          </select>
                          @if (lang === 'ja') { <span class="hidden-xs">年</span> }
                        </div>
                        <div class="col-lg-2 col-xs-4" style="padding:0">
                          <select class="form-control" style="width:80%" [(ngModel)]="member.tmp.birth_month" name="birthMonth" required>
                            <option [ngValue]="undefined">{{ 'month' | translate }}</option>
                            @for (m of birthMonths; track m) { <option [ngValue]="m">{{m}}</option> }
                          </select>
                          @if (lang === 'ja') { <span class="hidden-xs">月</span> }
                        </div>
                        <div class="col-lg-2 col-xs-4" style="padding:0">
                          <select class="form-control" style="width:80%" [(ngModel)]="member.tmp.birth_date" name="birthDate" required>
                            <option [ngValue]="undefined">{{ 'day' | translate }}</option>
                            @for (d of birthDates; track d) { <option [ngValue]="d">{{d}}</option> }
                          </select>
                          @if (lang === 'ja') { <span class="hidden-xs">日</span> }
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <!-- Nationality (entry only, non-visitors) -->
                  @if (!member.visitors && member.isEntry) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label">{{ 'nationality' | translate }}</label>
                        <span class="required">{{ 'required' | translate }}</span>
                      </div>
                      <div class="col-form form-inline">
                        @if (!isJapanese) { <div class="error"><p>{{ 'nationalityRequired' | translate }}</p></div> }
                        <div class="form-group w100p col-md-12 row">
                          <select class="form-control" [(ngModel)]="isJapanese" name="nationality" required>
                            <option [ngValue]="null">{{ 'nationality' | translate }}</option>
                            @for (n of nationalities; track n.id) {
                              <option [ngValue]="n">{{ n.name | translate }}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }

                  <!-- Email -->
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'emailAddress' | translate }}</label>
                      <span class="required">{{ 'required' | translate }}</span>
                    </div>
                    <div class="col-form form-inline">
                      @if (invalidEmail) { <div class="error"><p>{{ 'emailAlreadyUsed' | translate }}</p></div> }
                      @if (!member.email) { <div class="error"><p>{{ 'emailAddressRequired' | translate }}</p></div> }
                      <div class="form-group w70p">
                        <input class="form-control w100p mb15" oncopy="return false" onpaste="return false" oncontextmenu="return false"
                          type="text" pattern="^[a-zA-Z0-9_+\-]+(\.[a-zA-Z0-9_+\-]+)*@([a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$"
                          [(ngModel)]="member.email" name="email" required>
                        <p>{{ 'emailAddressValid' | translate }}</p>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  @if (!member.isRegistration) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label">{{ 'emailAddressReenter' | translate }}</label>
                        <span class="required">{{ 'required' | translate }}</span>
                      </div>
                      <div class="col-form form-inline">
                        @if (!member.confirmEmail) { <div class="error"><p>{{ 'emailAddressReenterRequired' | translate }}</p></div> }
                        @if (member.confirmEmail && member.email !== member.confirmEmail) { <div class="error"><p>メールアドレス確認用が一致していません</p></div> }
                        <div class="form-group w70p">
                          <input class="form-control w100p mb15" oncopy="return false" onpaste="return false" oncontextmenu="return false"
                            type="email" [(ngModel)]="member.confirmEmail" name="confirmEmail">
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }

                  <!-- Phone -->
                  <div class="application-row mb30">
                    <div class="col-label">
                      <label class="contact-label">{{ 'phoneNumber' | translate }}</label>
                      <span class="required">{{ 'required' | translate }}</span>
                    </div>
                    <div class="col-form form-inline">
                      @if (!member.tmp.tel1 || !member.tmp.tel2 || !member.tmp.tel3) { <div class="error"><p>{{ 'phoneNumberRequired' | translate }}</p></div> }
                      <div class="form-group w100p col-md-12 row">
                        <input convertAlphanumeric class="form-control w100" pattern="[0-9]+" type="text" [(ngModel)]="member.tmp.tel1" name="tel1" required>
                        <span>&nbsp;-&nbsp;</span>
                        <input convertAlphanumeric class="form-control w100" type="text" pattern="[0-9]+" [(ngModel)]="member.tmp.tel2" name="tel2" required>
                        <span>&nbsp;-&nbsp;</span>
                        <input convertAlphanumeric class="form-control w100" type="text" pattern="[0-9]+" [(ngModel)]="member.tmp.tel3" name="tel3" required>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <!-- Payment (entry only, non-visitors) -->
                  @if (!member.visitors && member.isEntry) {
                    <div>
                      <h2 class="title">{{ 'selectPaymentMethod' | translate }}</h2>
                      <p>{{ 'selectPaymentMethodMsg' | translate }}</p>
                      <div [class]="paymentMethod === '1' ? 'application-row' : 'application-row mb30'">
                        <div class="col-label">
                          <label class="contact-label">{{ 'paymentMethod' | translate }}</label>
                          <span class="required">{{ 'required' | translate }}</span>
                        </div>
                        <div class="col-form">
                          <div class="form-group col-md-12 row">
                            @if (gmoTokenError) { <div class="error"><p>クレジットカード支払は現在ご利用いただけません</p></div> }
                            @if (!paymentMethod) { <div class="error"><p>{{ 'paymentMethodRequired' | translate }}</p></div> }
                            <div class="radio">
                              <label style="width:100%;">
                                <input type="radio" [(ngModel)]="paymentMethod" name="paymentMethod" value="0" required (ngModelChange)="onPaymentMethodChange()">{{ 'directDebit' | translate }}
                              </label>
                            </div>
                            <div class="radio">
                              <label style="width:100%;">
                                <input type="radio" [(ngModel)]="paymentMethod" name="paymentMethod" value="1" required
                                  [disabled]="selectPlan === '999999999,見学予約,0,0'" (ngModelChange)="onPaymentMethodChange()">{{ 'creditCard' | translate }}
                              </label>
                            </div>
                            @if (paymentMethod === '1' && isDisplayedCcLink === 1) {
                              <p><a [href]="ccUrl" target="_blank">※クレジットカードをお持ちでない方はこちらから新規発行をお願いいたします。</a></p>
                            }
                            @if (selectPlan === '999999999,見学予約,0,0') { <p class="c-light-blue">※見学予約を選択した方は、口座振替が選択されます。</p> }
                            @if (paymentMethod === '0' && btPaymentEnabled === 1) { <p class="c-light-blue">{{ 'PleaseRegisterBankAccountOnline' | translate }}</p> }
                            @if (paymentMethod === '0' && btPaymentEnabled !== 1) { <p class="c-light-blue">{{ 'PleaseComeToTheBranch' | translate }}</p> }
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      @if (paymentMethod === '1') {
                        <div class="application-row">
                          <div class="col-label"><label class="contact-label">{{ 'cardNumber' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                          <div class="col-form form-inline">
                            @if (!member.cc.number) { <div class="error"><p>{{ 'cardNumberIsRequired' | translate }}</p></div> }
                            <div class="form-group w70p">
                              <input convertAlphanumeric class="form-control w100p mb15" type="text" [(ngModel)]="member.cc.number" name="ccNumber" pattern="[0-9]+" minlength="14" sfMaxLength="16" required>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="application-row">
                          <div class="col-label"><label class="contact-label">{{ 'nameOnCard' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                          <div class="col-form form-inline">
                            @if (!member.cc.name) { <div class="error"><p>{{ 'nameOnCardIsRequired' | translate }}</p></div> }
                            @if (member.cc.name && !isOKCcName) { <div class="error"><p>名義には半角英字および記号を入力してください。</p></div> }
                            <div class="form-group w70p">
                              <input class="form-control w100p mb15" type="text" [(ngModel)]="member.cc.name" name="ccName"
                                pattern="[a-zA-Z0-9 ,.\-/]+"
                                (ngModelChange)="checkPattern($event, '^[a-zA-Z0-9 ,\.\\-\\/]+$')" placeholder="例：SMART TARO" required>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="application-row">
                          <div class="col-label"><label class="contact-label">{{ 'expiryDate' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                          <div class="col-form form-inline">
                            @if (!member.cc.expire_month || !member.cc.expire_year) { <div class="error"><p>{{ 'expiryDateIsRequired' | translate }}</p></div> }
                            <div class="form-group w100p col-md-12 row">
                              <div class="col-lg-2 col-xs-4" style="padding:0">
                                <select class="form-control" style="width:80%" [(ngModel)]="member.cc.expire_month" name="ccExpireMonth" required>
                                  <option [ngValue]="undefined">{{ 'month' | translate }}</option>
                                  @for (m of ccExpireMonths; track m) { <option [ngValue]="m">{{m}}</option> }
                                </select>
                                @if (lang === 'ja') { <span class="hidden-xs">月</span> }
                              </div>
                              <div class="col-lg-2 col-xs-4" style="padding:0">
                                <select class="form-control" style="width:80%" [(ngModel)]="member.cc.expire_year" name="ccExpireYear" required>
                                  <option [ngValue]="undefined">{{ 'year' | translate }}</option>
                                  @for (y of ccExpireYears; track y) { <option [ngValue]="y">{{y}}</option> }
                                </select>
                                @if (lang === 'ja') { <span class="hidden-xs">年</span> }
                              </div>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="application-row mb30">
                          <div class="col-label"><label class="contact-label">{{ 'securityCode' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                          <div class="col-form form-inline">
                            <div class="form-group w70p">
                              <input convertAlphanumeric class="form-control w100p mb15" type="text" [(ngModel)]="member.cc.security" name="ccSecurity" pattern="[0-9]+" sfMaxLength="4" required>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      }
                      <!-- Start Date (unmanned + credit card) -->
                      @if (selectPlan && selectPlan !== '999999999,見学予約,0,0' && isUnmanned === 1 && paymentMethod === '1') {
                        <div class="application-row mb30">
                          <div class="col-label">
                            <label class="contact-label">{{ 'startDateOfUse' | translate }}</label>
                            <span class="required">{{ 'required' | translate }}</span>
                          </div>
                          <div class="col-form col-md-12 row">
                            <div class="form-group w100p">
                              @if (!member.desiredStartDate) { <div class="error"><p>{{ 'youMustSpecifyTheStartDateOfUse' | translate }}</p></div> }
                              <select class="form-control form-group" style="width:50%" [(ngModel)]="member.desiredStartDate" name="desiredStartDate"
                                (ngModelChange)="onDesiredStartDateChange()" required>
                                <option [ngValue]="undefined">{{ 'pleaseSelect' | translate }}</option>
                                @for (date of desiredStartDateList; track date.id) {
                                  <option [ngValue]="date">{{date.name}}</option>
                                }
                              </select>
                              <div class="form-group col-md-12 row">
                                <p>{{ 'desiredStartDateMsg1' | translate }}<br>{{ 'desiredStartDateMsg2' | translate }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      }
                    </div>
                  }

                  <!-- Emergency Contact (entry only, non-visitors) -->
                  @if (!member.visitors && member.isEntry) {
                    <div>
                      <h2 class="title">{{ 'emergencyContact' | translate }}</h2>
                      <p>{{ 'emergencyContactMsg' | translate }}</p>
                      <div class="application-row">
                        <div class="col-label"><label class="contact-label">{{ 'fullName' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                        <div class="col-form form-inline">
                          @if (!member.emLastName) { <div class="error"><p>{{ 'lastNameRequired' | translate }}</p></div> }
                          @if (!member.emFirstName) { <div class="error"><p>{{ 'firstNameRequired' | translate }}</p></div> }
                          @if (!member.emLastNameKana) { <div class="error"><p>{{ 'lastNameKanaRequired' | translate }}</p></div> }
                          @if (!member.emFirstNameKana) { <div class="error"><p>{{ 'firstNameKanaRequired' | translate }}</p></div> }
                          <div class="form-group col-md-12 row">
                            <label class="w70 col-xs-3 col-lg-2" style="padding:0">{{ 'kanji' | translate }}</label>
                            <div class="col-xs-4 col-lg-5"><input class="form-control" [placeholder]="'lastNameLabel' | translate" type="text" [(ngModel)]="member.emLastName" name="emLastName" required></div>
                            <div class="col-xs-4 col-lg-5"><input class="form-control" [placeholder]="'firstNameLabel' | translate" type="text" [(ngModel)]="member.emFirstName" name="emFirstName" required></div>
                          </div>
                          <div class="form-group col-md-12 row">
                            <label class="w70 col-xs-3 col-lg-2" style="padding:0">{{ 'kana' | translate }}</label>
                            <div class="col-xs-4 col-lg-5"><input class="form-control" [placeholder]="'lastNameKanaLabel' | translate" type="text" [(ngModel)]="member.emLastNameKana" name="emLastNameKana" required></div>
                            <div class="col-xs-4 col-lg-5"><input class="form-control" [placeholder]="'firstNameKanaLabel' | translate" type="text" [(ngModel)]="member.emFirstNameKana" name="emFirstNameKana" required></div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <div class="application-row">
                        <div class="col-label"><label class="contact-label">{{ 'relationship' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                        <div class="col-form form-inline">
                          @if (!emRelationship) { <div class="error"><p>{{ 'relationshipRequired' | translate }}</p></div> }
                          <div class="form-group w100p col-md-12 row">
                            <select class="form-control" [(ngModel)]="emRelationship" name="emRelationship" required>
                              <option [ngValue]="null">{{ 'relationship' | translate }}</option>
                              @for (r of relationships; track r.id) { <option [ngValue]="r">{{ r.name | translate }}</option> }
                            </select>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <div class="application-row mb30">
                        <div class="col-label"><label class="contact-label">{{ 'phoneNumber' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                        <div class="col-form form-inline">
                          <div class="form-group form-inline col-md-12 row">
                            @if (!member.tmp.emTel1 || !member.tmp.emTel2 || !member.tmp.emTel3) { <div class="error"><p>{{ 'phoneNumberRequired' | translate }}</p></div> }
                            <div class="form-group w100p">
                              <input convertAlphanumeric class="form-control w100" type="text" pattern="[0-9]+" [(ngModel)]="member.tmp.emTel1" name="emTel1" required>
                              <span>&nbsp;-&nbsp;</span>
                              <input convertAlphanumeric class="form-control w100" type="text" pattern="[0-9]+" [(ngModel)]="member.tmp.emTel2" name="emTel2" required>
                              <span>&nbsp;-&nbsp;</span>
                              <input convertAlphanumeric class="form-control w100" type="text" pattern="[0-9]+" [(ngModel)]="member.tmp.emTel3" name="emTel3" required>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  }

                  <!-- Terms of Use -->
                  <h2 class="title">
                    @if (!member.visitors && member.isEntry) { <span>{{ 'termsOfUse' | translate }}</span> }
                    @else { <span>{{ 'termsOfVisit' | translate }}</span> }
                  </h2>
                  <p>{{ 'termsOfUseMsg' | translate }}</p>
                  @if (!member.visitors && member.isEntry) {
                    <div class="application-row">
                      <div class="col-label"><label class="contact-label">{{ 'membershipTerms' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                      <div class="col-form form-inline">
                        @if (!member.tmp.agreement1) { <div class="error"><p>{{ 'membershipTermsRequired' | translate }}</p></div> }
                        <div class="form-group w100p">
                          <div [innerHTML]="agreementFor('agreement')"></div>
                          <div class="checkbox">
                            <label><input type="checkbox" [(ngModel)]="member.tmp.agreement1" name="agreement1" required>{{ 'agreeToMembershipTerms' | translate }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <div class="application-row">
                      <div class="col-label"><label class="contact-label">{{ 'rulesOfUse' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                      <div class="col-form form-inline">
                        @if (!member.tmp.agreement2) { <div class="error"><p>{{ 'rulesOfUseRequired' | translate }}</p></div> }
                        <div class="form-group w100p">
                          <div [innerHTML]="agreementFor('rule')"></div>
                          <div class="checkbox">
                            <label><input type="checkbox" [(ngModel)]="member.tmp.agreement2" name="agreement2" required>{{ 'agreeToRulesOfUse' | translate }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }
                  <div class="application-row mb30">
                    <div class="col-label"><label class="contact-label">{{ 'privacyPolicy' | translate }}</label><span class="required">{{ 'required' | translate }}</span></div>
                    <div class="col-form form-inline">
                      @if (!member.tmp.agreement3) { <div class="error"><p>{{ 'privacyPolicyRequired' | translate }}</p></div> }
                      <div class="form-group w100p">
                        <div [innerHTML]="agreementFor('pi-agreement')"></div>
                        <div class="checkbox">
                          <label><input type="checkbox" [(ngModel)]="member.tmp.agreement3" name="agreement3" required>{{ 'agreeToPrivacyPolicy' | translate }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>

                <!-- Questionnaire -->
                @if (!member.isRegistration && member.isEntry || member.status === 6) {
                  <div>
                    @if (!member.visitors && member.isEntry) { <h2 class="title">{{ 'questionnaire' | translate }}</h2> }
                    @else { <h2 class="title">ご来館アンケート</h2> }
                    <p>{{ 'questionnaireMsg' | translate }}</p>
                    @for (entry of questionaryEntries(); track entry[0]) {
                      <div class="application-row" [class.mb30]="$last">
                        <div class="col-label">
                          <label class="contact-label row col-md-8">{{entry[1].questionaryContent}}</label>
                          @if (entry[1].isMultiSelect) { <label class="contact-label" style="padding-right:15px">(複数選択可)</label> }
                          @if (!entry[1].freeFlg) { <span class="required">{{ 'required' | translate }}</span> }
                        </div>
                        <div class="col-form">
                          <!-- Radio -->
                          @if (entry[1].freeFlg === 0 && entry[1].isMultiSelect === 0) {
                            <div class="form-group col-md-12 row">
                              @if (!entry[1].selectColumns.value) { <div class="error"><p>{{ 'questionnaireRequired' | translate }}</p></div> }
                              @for (col of columnEntries(entry[1].selectColumns); track col[0]) {
                                <div class="radio">
                                  <label style="width:100%;">
                                    <input type="radio" [(ngModel)]="entry[1].selectColumns.value" [name]="'q_' + entry[0]"
                                      [value]="col[1].id" [required]="!entry[1].selectColumns.value"
                                      (ngModelChange)="toggleRadio(+entry[0], col[1].id)">{{col[1].name}}
                                  </label>
                                  @if (col[1].inputMemoFlg === 1 && entry[1].selectColumns.value == col[1].id) {
                                    <div style="margin:10px 0 -15px">{{col[1].inputMemoContent}}</div>
                                    <label style="padding:0">
                                      <textarea [(ngModel)]="entry[1].selectColumns.inputMemo" [name]="'qm_' + entry[0]" class="form-control" rows="4" cols="40" maxlength="255" placeholder="255文字以下でご入力ください。"></textarea>
                                    </label>
                                  }
                                </div>
                              }
                            </div>
                          }
                          <!-- Free text -->
                          @if (entry[1].freeFlg === 1) {
                            <div class="form-group col-md-12 row">
                              @for (col of columnEntries(entry[1].selectColumns); track col[0]) {
                                <label>
                                  <textarea [(ngModel)]="entry[1].selectColumns.inputMemo" [name]="'qf_' + entry[0]" class="form-control" rows="4" cols="40" maxlength="255" placeholder="255文字以下でご入力ください。"></textarea>
                                </label>
                              }
                            </div>
                          }
                          <!-- Checkbox -->
                          @if (entry[1].isMultiSelect === 1) {
                            <div class="form-group col-md-12 row">
                              <input type="hidden" [(ngModel)]="entry[1].selectColumns.hasCheck"
                                [name]="'q_required_' + entry[0]" required>
                              @if (!entry[1].selectColumns.hasCheck) { <div class="error"><p>{{ 'questionnaireRequired' | translate }}</p></div> }
                              @for (col of columnEntries(entry[1].selectColumns); track col[0]) {
                                <div class="checkbox">
                                  <label>
                                    <input type="checkbox" [(ngModel)]="entry[1].check[col[1].id]" [name]="'qc_' + entry[0] + '_' + col[0]"
                                      [value]="col[1].id" (ngModelChange)="toggleCheck(+entry[0], col[1].id)">{{col[1].name}}
                                  </label>
                                  @if (col[1].inputMemoFlg === 1 && entry[1].selectColumns.value?.includes(col[1].id)) {
                                    <div style="margin:10px 0 -15px">{{col[1].inputMemoContent}}</div>
                                    <label style="padding:0">
                                      <textarea [(ngModel)]="entry[1].selectColumns.inputMemo" [name]="'qcm_' + entry[0]" class="form-control" rows="4" cols="40" maxlength="255" placeholder="255文字以下でご入力ください。"></textarea>
                                    </label>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Submit -->
              <div class="text-center">
                @if (invalidEmail) { <div class="error"><p>入力内容に不備があります</p></div> }
                @if (gmoTokenError) { <div class="error"><p>クレジットカード支払は現在ご利用いただけません</p></div> }
                @if (confirmationError) { <div class="error registration-confirmation-error" role="alert">{{ confirmationError }}</div> }
                @if (quote.error) { <div class="error registration-quote-error" role="alert">{{ quote.error }} <button type="button" (click)="loadFirstInvoice()" [disabled]="quote.loading">再取得</button></div> }
                @if (confirming || quote.loading) { <p role="status">入力内容を確認しています…</p> }
                <button type="submit" class="btn-application-1"
                    [disabled]="confirming || stepTwoForm.pending || (requiresQuestionary && (!questionaryLoaded || questionaryLoading)) || stepTwoForm.invalid || (!member.isRegistration && member.email !== member.confirmEmail)">
                  {{ 'inputConfirmation' | translate }}
                </button>
              </div>
            </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </section>

  <!-- Visit Date Modal -->
  @if (showVisitModal) {
    <div class="modal-backdrop fade show" style="display:block"></div>
    <div class="modal fade show" id="visitModal" style="display:block" tabindex="-1" role="dialog" aria-labelledby="visitModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document" style="max-width:1200px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="visitModalLabel"><i class="fa fa-calendar"></i>&nbsp;見学希望日選択</h5>
            <button type="button" class="close" (click)="closeVisitModal()"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="card-body">
              <full-calendar [options]="calendarOptions"></full-calendar>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" (click)="closeVisitModal()">
              <span class="material-symbols-outlined" style="vertical-align:bottom">cancel</span>&nbsp;閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
